import React, { Fragment } from 'react'
import Helmet from 'react-helmet'

const LoadingBox = () => {
  return (
    <Fragment>
      <Helmet>
        <title>{`${process.env.RAZZLE_TITLE} - Carregando`}</title>
      </Helmet>
      <div id='box-login' className={`box-login row pb-4`}>
        <div className='col-12 col-md-6 col-lg-5 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3 pb-5 mb-5'>
          <div className='row'>
            <div className='col-12 py-half txt-body-sm bg-ui-3 radius' />
            <div className='col-6 py-half txt-body-sm bg-ui-4 radius mt-2' />
            <div className='col-12 py-half txt-body-sm bg-white border border-color-ui-3 radius py-2 mt-2' />
            <div className='col-12 py-half txt-body-sm bg-ui-3 radius pt-2 pb-3 mt-2' />
            <div className='col-4 py-half txt-body-sm bg-white radius mt-2' />
            <div className='col-4 py-half txt-body-sm bg-ui-4 radius mt-2' />
            <div className='col-4 py-half txt-body-sm bg-white radius mt-2' />
          </div>
        </div>
      </div>
    </Fragment>
  )
}

LoadingBox.propTypes = {}

export default LoadingBox
